export default {
    methods: {
        trackEvent(event_type, eventable_id, eventable_type, meta = [], param = {}) {
            let cc = null;
            const currentURL = new URL(location.href);
            if (currentURL.searchParams.get('cc')) {
                cc = currentURL.searchParams.get("cc");
            }
            let source = param['source'] ?? window.location.href;
            let target = param['target'] ?? null;

            axios.post('/events',{
                event_type : event_type,
                source : source,
                target : target,
                eventable_id : eventable_id,
                eventable_type : eventable_type,
                meta : meta,
                cc : cc
            }).then(() => {

            }).catch((error) => {

            });
        },

        /**
         * @param {string|null} redirect_url
         * @param {string} target
         */
        checkRedirectUrl(redirect_url, target) {
            if(redirect_url){
                window.open(redirect_url, target);
            }
        },

        trackJobFullAppClick(job_id, redirect_url = null, thankyou_url = null, type = 'fullapp') {
            let event_type = (type === 'interview') ? 'INTERVIEW_CLICK' : 'FULL_APPLICATION_CLICK';
            let url = new URL(redirect_url);
            if (url.origin === window.location.origin) {
                url.searchParams.set('thankyou', 1);
            }
            let param = {};
            param['target'] = redirect_url;
            redirect_url = url.href;
            this.trackEvent(event_type, job_id, 'Job', [], param);
            axios.post('/update_session_job',{ job_id })
                .then(() => {
                    this.checkRedirectUrl( redirect_url, '_blank' );

                    this.checkRedirectUrl( thankyou_url, '_self' );
                });
        },

        handlePhoneClick(job_id, target = null) {
          // Redirect immediately then track the event;
          this.checkRedirectUrl( target, '_self' );

          this.trackPhoneClick(job_id, target);
        },

        trackPhoneClick(job_id, target = null) {
            let param = {};
            param['target'] = target;
            this.trackEvent('APP_PHONE_CLICK', job_id, 'Job',[], param);
            axios.post('/update_session_job', { job_id });
        },

        trackJobApplyButtonClick(job_id, job_slug, redirect_url, redirect_url_out, target ){
            this.trackEvent('JOB_APPLICATION_CLICK', job_id, 'Job' );

            // if target is _blank the next one will be triggered
            // if target is self, no need to execute below
            this.checkRedirectUrl( redirect_url, target );

            // If the target is _blank, It is a linkout only url
            // We need to redirect the user to thank you page.
            if( target === '_blank'){
                window.open(redirect_url_out, '_self');
            }
        }
    }
}
